var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 45,
    viewBox: "0 0 51 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.598221 18.789L25.3599 9.62842L37.6094 5.08878C41.5675 3.61934 45.5319 2.03734 49.7527 1.53085L49.1774 0.530382C41.2861 15.9064 28.4114 27.9683 20.2137 43.1568C19.7323 44.0447 21.0891 44.8388 21.5643 43.9509C29.6932 28.7374 42.5055 16.6067 50.3279 1.19944C50.528 0.805507 50.2904 0.130184 49.7527 0.198967C45.7133 0.705456 41.9302 2.10612 38.1409 3.53805C33.9723 5.10963 29.8036 6.68537 25.635 8.26528L0.33557 17.8323C-0.245955 18.0512 -0.0020621 19.0016 0.598221 18.7765V18.789Z",
    fill: "#4E4E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6523 0.930625C44.2752 3.70694 40.0294 6.66458 35.8775 9.75979C33.9328 11.2042 32.0257 12.6987 30.131 14.1994C28.2364 15.7001 25.8602 17.1633 24.397 19.0892C23.8843 19.7583 24.8472 20.4961 25.4725 20.1647C27.5298 19.0892 29.3243 17.0757 31.1002 15.6063C32.876 14.1369 34.902 12.5361 36.8279 11.0229C40.8548 7.84639 44.9567 4.76994 49.0712 1.68098C49.5026 1.35582 49.115 0.62423 48.6272 0.930625H48.6523Z",
    fill: "#4E4E4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.315083 19.2642C4.38576 20.1521 8.84414 20.077 13.0023 20.3272C17.5063 20.6325 22.0239 20.6847 26.5338 20.4835C27.4967 20.4335 27.4967 18.9265 26.5338 18.9828C22.1567 19.2329 17.7108 19.1391 13.3087 18.9828C9.08799 18.8077 4.62338 18.1637 0.408893 18.5763C0.0337155 18.6139 -0.116371 19.2016 0.315083 19.2892V19.2642Z",
    fill: "#4E4E4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4432 16.7756C25.9925 25.8611 21.3778 34.115 20.2711 43.2818C20.1397 44.3386 21.803 44.3261 21.9281 43.2818C23.0286 34.2151 27.8183 26.0675 28.5312 16.9194C28.5812 16.2941 27.5432 16.1565 27.4432 16.7756Z",
    fill: "#4E4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.9907d749f540b6e5f692e2e1b19796ef.svg";
export { ForwardRef as ReactComponent };